const FALLBACK_TITLE_SLUG = 'post';

export function slugifyBlogTitle(title) {
    const raw = typeof title === 'string' ? title : String(title || '');

    const normalized = raw
        .normalize('NFKD') // convert accented characters to their base characters (e.g. 'é' -> 'e')
        .replace(/[\u0300-\u036f]/g, '') // It works together with .normalize('NFKD')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-') // convert spaces, punctuation, symbols, etc. into '-'
        .replace(/^-+|-+$/g, '') // remove leading and trailing '-'
        .replace(/-{2,}/g, '-'); // replace multiple '-' with a single '-'

    return normalized || FALLBACK_TITLE_SLUG;
}

export function buildBlogDetailPath(id, title) {
    const idPart = encodeURIComponent(String(id || '').trim());
    const titlePart = encodeURIComponent(slugifyBlogTitle(title));
    return `/blog/detail/${idPart}/${titlePart}`;
}

/**
 * Canonical blog list path. Page 1 always includes `/1`.
 * /blog and /blog/{slug} are aliases that should 301 here.
 */
export function buildBlogListPath(slug, page) {
    const normalizedSlug = slug ? String(slug).toLowerCase() : 'all';
    const categoryPart = !normalizedSlug || normalizedSlug === 'all' ? 'all' : normalizedSlug;
    const pageNum = page != null && page !== '' ? Number(page) : 1;
    const safePage = Number.isInteger(pageNum) && pageNum > 0 ? pageNum : 1;
    return `/blog/${categoryPart}/${safePage}`;
}
